import $ from 'jquery';
import Swiper, { Pagination, EffectFade , Autoplay } from 'swiper';

function initHeroBannerSlider() {
  $(function () {
    if ($('.hero-banner-slider').length <= 0) {
      return;
    }
    $('.hero-banner-slider').each(function () {
      let $block = $(this);
      let slider = $(this).find('.swiper-container');
      let pagination = $(this).find('.swiper-pagination');
      let imagesSlider = $block.find('.hero-banner__image-slider');
      let imagesSliderItem = $block.find('.hero-banner__image-slider li');

      let swiper = new Swiper(slider.get(0), {
        modules: [Pagination, EffectFade , Autoplay], // Include EffectFade here
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 100,
        effect: 'fade', // Make sure to set the effect as 'fade'
        pagination: {
          el: pagination.get(0),
          clickable: true
        },
        fadeEffect: {
          crossFade: true // Optional: set to true for a smooth cross-fade transition
        },
        on: {
          slideChange: function () {
            // Check if the image slider exists
            if (imagesSlider.length) {
              let activeIndex = swiper.realIndex; // Get the real index of the active slide
              imagesSliderItem.filter(`.active`).removeClass('active').fadeOut(200 , function(){
                imagesSliderItem.filter(`[data-slide="${activeIndex}"]`).addClass('active').fadeIn(200); // Show the image corresponding to the active slide
              }); // Hide all images
            }
          }
        }
      });
    });
  });
}

export { initHeroBannerSlider };
